
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { KnowledgeWidget } from '../../../../_metronic/partials/widgets/feeds/KnowledgeWidget'
import { getAllVisibleKnowledgeByMenuID } from '../../auth/core/_api'
import { knowledgeModel } from '../../../../app/modules/auth';

const KnowledgeManagement: FC = () => {
  const [knowledges, setKnowledges] = useState<knowledgeModel[]>()

  useEffect(() => {
    async function updateDegreeName() {
      const items = await getAllVisibleKnowledgeByMenuID("1")
      var item_arr = new Array<knowledgeModel>()
      items.data.results.forEach((item: knowledgeModel) => {
        item_arr.push(item)
      });
      setKnowledges(item_arr)
  };
  updateDegreeName();
  },[])
  
  return (
    <EnableSidebar>
      <div className='d-flex flex-stack flex-wrap'>
        <div className='d-flex align-items-center py-1'>
          <h1 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
            การจัดการความรู้
          </h1>
        </div>
      </div>

      {knowledges && knowledges.map((item, i) => {
          return (
          <KnowledgeWidget 
              key={i}
              id={item.id}
              icon='/media/avatars/guide.png'
              class_name='mb-2 mb-xxl-5'
              title={item.title}
              detail={item.description}
              pdf_file={item.pdf_file} 
              datetime={item.updated_at}
              source_parent="knowledge_management" />
          )
      })}

    </EnableSidebar>
  )
}

export { KnowledgeManagement }